const keys = {
    googleKey: "AIzaSyARtFCDkKcXMjbEZz19w45A-jeG00286jU",
    cloudName: "dgupilxum",
    uploadPreset: "lbpxurzh",
    appId: "971095640238509",
    appIdDev: "722154868837144"
};

export default {
    keys
}